<template>
  <div id='addApp' class='gPageBorder' v-loading='loading'>
   
     <el-row>
       <el-col :span='4'>
         <el-button class='gSgLeftBtn' @click="multiAdd" style=''>{{$t('app_mulAdd')}} ({{sNum}})</el-button>
       </el-col>
       <el-col :span='8'>
         <div class='gSpDiv'></div>
       </el-col>
       <el-col :span='4'>
         <div class='gCtrl'>
          <MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
         </div>
       </el-col>
       <el-col :span='4'>
          <el-cascader
            class='gCtrl'
            expand-trigger="hover"
            :options="appTypes"
            @change='selectChange'
            :show-all-levels="false"
            v-model="appType"
          ></el-cascader>

       </el-col>
       <el-col :span='4'>
         <div class='gSideCtrl'><el-input :placeholder="$t('app_appName')" v-model='queryKey' @keyup.enter.native='query' :on-icon-click='query' icon='search'></el-input></div>
       </el-col>
     </el-row>


   
      <div class='gTopMg'>
        <el-table
          ref="multipleTable"
          :data="tableData"
          border
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">

          <el-table-column
            align='center'
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            align='center'
            prop="appName"
            :label="$t('app_appName')"
            width="">
          </el-table-column>
          <el-table-column
            align='center'
            prop="appCategoryName"
            :label="$t('app_type')"
            width="">
          </el-table-column>
          <el-table-column
            align='center'
            prop="distributorName"
            :label="$t('app_distributor')"
            width="">
          </el-table-column>
          <el-table-column
            align='center'
            prop="appInstallType"
            :label="$t('app_insType')"
            width=''>
            <template slot-scope='scope'>
              <label>{{setInstallType(scope.row.appInstallType)}}</label>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            align='center'
            :formatter="dateFormat"
            :label="$t('app_ulTime')"
            width='175'>
          </el-table-column>
          <el-table-column
            align='center'
            prop="appVersion"
            :label="$t('app_version')"
            width=''>
          </el-table-column>
          <el-table-column
            prop="operate"
            align='center'
            :label="$t('app_operate')"
            width='90'>
            <template slot-scope='scope'>
              <!-- <el-button @click='addAppToMyList(scope.row)' type=text>{{$t('app_add')}}</el-button> -->
              <el-tooltip class="item" effect="dark" :content="$t('app_add')" placement="top">
                <el-button type='text'  @click='addAppToMyList(scope.row)'><i class="fa fa-plus-square" style=""></i></el-button>
              </el-tooltip>
             
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style>
  #addApp{}

  #aaMain{}

  #aaSrch{height:20%;background:none;position:relative;overflow:hidden;text-align:left;}
    #aaSrch label{font-size:14px;}

  #aaData{height:65%;background:none;}

  #aaPage{overflow:hidden;background:none;margin-top:10px;}
      #aaPage div{float:right;margin-right:2px;}
  .rcm{text-align:center;width:calc(100% + 40px);margin-left:-20px;border-collapse: collapse;}
  .rcRowStyle{border-top:1px solid #D3DCE6;border-bottom:1px solid #D3DCE6;height:35px;}
  .rcRowCtStyle{}

</style>

<script>
  // import $ from 'jquery'
  import mm from 'moment'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      return {
        mechanismData: '',
        sNum: 0,
        loading: 0,
        rcm: {}, // 弹窗推荐值
        checked: false, // 推荐全选值
        mechanismId: window.localStorage['mechanismId'],
        mechId: '',
        queryKey: '',
        appType: '',
        appTypes: [],
        row: this.$gRow,
        total: 0,
        tableData: [],
        selected: [],
        recommends: [
          {name: 'a', vl: false},
          {name: 'b', vl: false},
          {name: 'c', vl: false}
        ],
        recommendVl: false
      }
    },
    computed: {
      index () {
        return this.$getWPage('appMarketAddPage')
      }
    },
    watch: {
      'recommendVl': 'selectAll'
    },
    components: {MechanismSelector},
    methods: {
      selectAll (vl) {
        if (vl) {
          var arr = []
          this.recommends.forEach((vl) => {
            vl.vl = true
            arr.push(vl)
          })
          this.recommends = arr
        } else {
          var uArr = []
          this.recommends.forEach((vl) => {
            vl.vl = false
            uArr.push(vl)
          })
          this.recommends = uArr
        }
      },
      saveRecommend () {
        console.log(this.recommends)
      },
      addReq (id, mId) {
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$addAppToDistributeList(id, mId, (res) => {
            // alert('rt')
            this.loading = 0
            this.$message(res.message)
            this.getAppList()
          }, () => {
            // error
            //alert('errrt')
            this.loading = 0
          })
        } else {
          this.$addAppToDistributeList1(id, mId, (res) => {
            // alert('rt')
            this.loading = 0
            this.$message(res.message)
            this.getAppList()
          }, () => {
            // error
            //alert('errrt')
            this.loading = 0
          })
        }
        
      },
      handleSelectionChange (list) {
        this.sNum = list.length
        this.selected = list
      },
      addAppToMyList (row) {
        this.addReq(row.applicationid, this.mechanismId)
      },
      appRecommend (row) {
        /* this.dialogTopMgVisible = 1
        console.log(row) */
      },
      query () {
        this.getAppList()
      },
      pageSelect (index) {
        this.$setWPage('appMarketAddPage', index)
        this.getAppList(index)
      },
      pageSized (val) {
        this.$gRow = val
        this.getAppList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getAppList()
      },
      selectChange (vl) {
        this.getAppList()
      },
      getTypeList (mcid) {
        var mc = mcid?mcid:''
        this.$gpAppType(mcid, (res) => {
          if (res.data.length > 0) {
            this.appTypes = res.data[0].children
          }
        })
        /*this.$getAppTypeList(100000000, 1, (res) => {
          if (res.status === 200) {
            // console.log(res)
            this.appTypes = res.data
          } else {
            this.$message(res.message)
          }
        }, '')*/
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      getAppList (isAppType) {
        this.loading = 1
        var type = this.appType.length > 0 ? this.appType[0] : ''
        var name = this.queryKey ? this.queryKey : ''
        var mcid = this.mechId?this.mechId : this.mechanismId
        if (isAppType) {
          this.getTypeList(mcid)
        }

        if (this.$appUrlTag === 0) {

          this.$getDAppList(this.$gRow, this.$getWPage('appMarketAddPage'), type, name, '2', mcid, '', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.total = res.total
              this.tableData = res.data
            } else {
              this.$message(res.message)
            }
          }, (res) => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        } else {
          this.$getDAppList1(this.$gRow, this.$getWPage('appMarketAddPage'), type, name, '2', mcid, '', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.total = res.total
              this.tableData = res.data
            } else {
              this.$message(res.message)
            }
          }, (res) => {
            this.loading = 0
            this.$message.error(this.$t('app_rqsError'))
          })
        }
        
      },
      multiAdd () {
        // this.toggleSelection(this.tableData)
        var ids = ''
        var arr = this.selected
        if (arr.length < 1) {
          this.$message(this.$t('app_chooseOneMust'))
          return
        }
        arr.forEach((vl) => {
          ids += vl.applicationid + ','
        })
        ids = ids.substring(0, ids.length - 1)
        // console.log(ids)
        this.addReq(ids, this.mechanismId)
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      close () {
        this.$appstore.commit('showAddApp', 0)
      },
      popRecommend () {
      }
    },
    mounted () {
      var _this = this
      this.mechanismData = {
        callback (value) {
          _this.mechId = value
          _this.getAppList(true)
        }
      }
      this.getAppList(true)
    }
  }
</script>



// WEBPACK FOOTER //
// addAppToDistribute.vue?488590bd